/**
 * ProductTourDescription Component
 * 
 * Tour description section (uzun/kısa açıklama, relevant for you, what is expected)
 */

'use client';

import { motion } from 'framer-motion';
import { headerVariants, cardVariants } from '@/lib/animations';
import { sanitizeCmsHtml } from '@/lib/sanitize-cms-html';

export interface ProductTourDescriptionProps {
    description: string | null;
    shortDescription: string | null;
    relevantForYou: string | null;
    whatIsExpected: string | null;
    language?: string;
    translations?: Record<string, string>;
}

export default function ProductTourDescription({
    description,
    shortDescription,
    translations = {},
}: ProductTourDescriptionProps) {
    const t = (key: string, fallback: string): string => {
        return translations[key] || fallback;
    };

    return (
        <div>
            <motion.h2
                className="text-xl lg:text-3xl font-bold text-alsero-dark-gray mb-6"
                variants={headerVariants}
            >
                {t('description', 'Description')}
            </motion.h2>

            {/* Long Description */}
            {description && description.trim() && (
                <motion.div
                    className="text-alsero-text-tour leading-relaxed mb-6"
                    variants={cardVariants}
                    dangerouslySetInnerHTML={{ __html: sanitizeCmsHtml(description.trim()) }}
                />
            )}
        </div>
    );
}

